import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import PublicUpload from "@/pages/PublicUpload";
import AdminLogin from "@/pages/AdminLogin";
import AdminSubmissions from "@/pages/AdminSubmissions";
import AdminReview from "@/pages/AdminReview";
import AttorneyRegister from "@/pages/AttorneyRegister";
import AdminAttorneys from "@/pages/AdminAttorneys";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/upload" replace />} />
          <Route path="/upload" element={<PublicUpload />} />
          <Route path="/register" element={<AttorneyRegister />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
          <Route path="/admin/review/:id" element={<AdminReview />} />
          <Route path="/admin/attorneys" element={<AdminAttorneys />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;